import { createContext } from '../utils/create-context';

type SearchComboboxContext = {
  listVisible: boolean;
  setListVisible: (v: boolean) => void;
};

export const [SearchComboboxContextProvider, useSearchComboboxContext] =
  createContext<SearchComboboxContext>('SearchComboboxContext');
